import { writable, readable } from 'svelte/store';
import validate from 'validate.js';
import Swal from "sweetalert2";
// import { curry } from 'ramda';

export function generate_random_string(length, characters) {
    let result           = '';
    if(characters === undefined) characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export function generic_validation(constraints, field_name, value) {
    // console.log("calling validation fuction");
    // console.log(field_name);
    // console.log(value);
    // console.log(constraints);
    let validator = {};
    validator[field_name] = value;
    let vres = validate(validator, constraints);
    // console.log(vres);
    if(vres !== undefined && field_name in vres) {
        return [false, vres[field_name][0], undefined];
    } else {
        return [true, "", undefined];
    }
}

export function add_days_to_date(date, num_days) {
    const new_date = date;
    new_date.setDate(new_date.getDate() + num_days);
    return new_date;
}

export function format_date_to_default_string(new_date){
    if(new_date === undefined) new_date = new Date();
    let mon = ((new_date.getMonth() > 8) ? (new_date.getMonth() + 1) : ("0" + (new_date.getMonth() + 1)));
    let day = new_date.getDate();
    if(day <= 9) {
        day = "0" + day;
    }
    let year = new_date.getYear()-100;
    return `${mon}/${day}/${year}`;
}

export function isNonEmpty(test_str) {
    return (test_str !== undefined && test_str !== null && test_str.trim().length > 0);
}

export const currency_formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});

// export const trial_domain_suffix = '-trial';
export const trial_domain_suffix = '';

// USEFUL VARS
export const us_state_array = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
];

export const state_codes = {
	'Alabama': 'AL',
	'Alaska': 'AK',
	'Arizona': 'AZ',
	'Arkansas': 'AR',
	'California': 'CA',
	'Colorado': 'CO',
	'Connecticut': 'CT',
	'Delaware': 'DE',
    'DC': 'DC',
	'Florida': 'FL',
	'Georgia': 'GA',
	'Hawaii': 'HI',
	'Idaho': 'ID',
	'Illinois': 'IL',
	'Indiana': 'IN',
	'Iowa': 'IA',
	'Kansas': 'KS',
	'Kentucky': 'KY',
	'Louisiana': 'LA',
	'Maine': 'ME',
	'Maryland': 'MD',
	'Massachusetts': 'MA',
	'Michigan': 'MI',
	'Minnesota': 'MN',
	'Mississippi': 'MS',
	'Missouri': 'MO',
	'Montana': 'MT',
	'Nebraska': 'NE',
	'Nevada': 'NV',
	'New Hampshire': 'NH',
	'New Jersey': 'NJ',
	'New Mexico': 'NM',
	'New York': 'NY',
	'North Carolina': 'NC',
	'North Dakota': 'ND',
	'Ohio': 'OH',
	'Oklahoma': 'OK',
	'Oregon': 'OR',
	'Pennsylvania': 'PA',
	'Rhode Island': 'RI',
	'South Carolina': 'SC',
	'South Dakota': 'SD',
	'Tennessee': 'TN',
	'Texas': 'TX',
	'Utah': 'UT',
	'Vermont': 'VT',
	'Virginia': 'VA',
	'Washington': 'WA',
	'West Virginia': 'WV',
	'Wisconsin': 'WI',
	'Wyoming': 'WY',
    '': ''
};

export const currency_codes = ['USD', 'CAD', 'EUR', 'AED', 'AFN', 'ALL', 'AMD', 'ARS', 'AUD', 'AZN', 'BAM', 'BDT', 'BGN', 'BHD', 'BIF', 'BND', 'BOB', 'BRL', 'BWP', 'BYN', 'BZD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EEK', 'EGP', 'ERN', 'ETB', 'GBP', 'GEL', 'GHS', 'GNF', 'GTQ', 'HKD', 'HNL', 'HRK', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KHR', 'KMF', 'KRW', 'KWD', 'KZT', 'LBP', 'LKR', 'LTL', 'LVL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MOP', 'MUR', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SDG', 'SEK', 'SGD', 'SOS', 'SYP', 'THB', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'UYU', 'UZS', 'VEF', 'VND', 'XAF', 'XOF', 'YER', 'ZAR', 'ZMK', 'ZWL'];

export const country_codes = {
    'United States': 'US',
    'Canada': 'CA'
};

export const show_alert = (title, content) => {
    if (!content) return;

    const html = `<div style="width: 100%; text-align: left;">${content}</div>`;

    Swal.fire({
        title,
        html,
        buttonsStyling: true,
        confirmButtonClass: 'button',
        confirmButtonText: 'OK',
        showCancelButton: false,
    }).then(async (e) => {
        console.log(e);
    });
}
